import { userPermissionsEnum } from '../../../Core/Users/enums/user-permissions.enum';
import { NavItem, NavItemType } from '../../../Common/Layout/components/Navbar/navbar.component';
import { HubspotFormTypeEnum } from '../../../Common/Misc/enums/hubspot-form-type.enum';

export const mediaRelationsNavItem: NavItem = {
    label: 'Core.navigation.mediaRelations',
    id: 'primaryNavMediaRelations',
    permissions: [
        userPermissionsEnum.advancedTargeting,
        userPermissionsEnum.newsroom,
        userPermissionsEnum.newswireplus
    ],
    items: [
        {
            label: 'Core.navigation.mediaRelations.contacts',
            icon: 'fa-kit-duotone fa-agpr-discover-contact',
            subLabel: 'Core.navigation.mediaRelations.contacts.subLabel',
            routerLink: '/Discover/targetingsearches/search',
            id: 'mediaRelationsContacts',
            permissions: [
                userPermissionsEnum.advancedTargeting
            ],
        },
        {
            label: 'Core.navigation.mediaRelations.savedSearches',
            icon: 'fa-kit-duotone fa-agpr-saved-search',
            subLabel: 'Core.navigation.mediaRelations.savedSearches.subLabel',
            routerLink: '/Discover/targetingsearches',
            itemSelectPath: '/Discover/targetingsearches/search/',
            id: 'mediaRelationsSavedSearches',
            permissions: [
                userPermissionsEnum.advancedTargeting
            ],
        },
        {
            label: 'Core.navigation.mediaRelations.targetedLists',
            icon: 'fa-kit-duotone fa-agpr-targeted-list',
            subLabel: 'Core.navigation.mediaRelations.targetedLists.subLabel',
            routerLink: '/Discover/targetinglists',
            id: 'mediaRelationsLists',
            permissions: [
                userPermissionsEnum.advancedTargeting
            ],
        },
        {
            label: 'Core.navigation.mediaRelations.distributions',
            icon: 'fa-kit-duotone fa-agpr-distribution',
            subLabel: 'Core.navigation.mediaRelations.distributions.subLabel',
            routerLink: '/Discover/distributions',
            id: 'primaryNavDistributions',
            permissions: [
                userPermissionsEnum.advancedTargeting
            ],
        },
        {
            label: 'Core.navigation.mediaRelations.newsroom',
            icon: 'fa-dCore.navigation.amplify.newsroomuotone fa-regular fa-bullhorn',
            subLabel: 'Core.navigation.mediaRelations.newsroom.subLabel',
            routerLink: '/Newsroom',
            id: 'primaryNavNewsroom',
            permissions: [
                userPermissionsEnum.newsroom
            ]
        },
        {
            label: 'Core.navigation.mediaRelations.newswire',
            icon: 'fa-duotone fa-regular fa-globe',
            subLabel: 'Core.navigation.mediaRelations.newswire.subLabel',
            routerLink: '/Amplify/wires',
            id: 'primaryNavNewswire',
            permissions: [
                userPermissionsEnum.newswireplus
            ]
        },
        {
            label: 'Core.navigation.mediaRelations.influencerStreams',
            icon: 'fa-kit-duotone fa-agpr-influencer-streams',
            subLabel: 'Core.navigation.mediaRelations.influencerStreams.subLabel',
            routerLink: '/Discover/influencerstreams',
            disabledTooltip: 'Core.navigation.mediaRelations.influencerStreams.disabled',
            id: 'mediaRelationsInfluencerStreams',
            permissions: [
                userPermissionsEnum.influencerStreams
            ]
        },
        {
            label: 'Core.navigation.mediaRelations.privateContacts',
            icon: 'fa-kit-duotone fa-agpr-private-contact',
            subLabel: 'Core.navigation.mediaRelations.privateContacts.subLabel',
            routerLink: '/Discover/privatecontacts',
            id: 'mediaRelationsPrivateContacts',
            permissions: [
                userPermissionsEnum.advancedTargeting
            ],
        },
        {
            label: 'Core.navigation.mediaRelations.visibilityIntelligence',
            icon: 'fa-kit-duotone fa-agpr-ai-visibility',
            subLabel: 'Core.navigation.mediaRelations.visibilityIntelligence.subLabel',
            routerLink: '/visibility-intelligence',
            id: 'primaryNavVisibilityIntelligence',
            permissionsValidator(permissions: userPermissionsEnum[]) {
                return (
                    permissions.includes(userPermissionsEnum.advancedTargeting)
                    && permissions.includes(userPermissionsEnum.openAI)
                    && permissions.includes(userPermissionsEnum.visibilityIntelligence)
                );
            },
            disabledTooltip: 'Core.navigation.mediaRelations.visibilityIntelligence.disabled',
            // TODO: NEP-38233 - Only a placeholder text to enable the lock/upsell behavior,
            // add more information once marketing message is received.
            upsellMessage: 'visibility Intelligence Upsell',
            upsellPopup: {
                // Placeholder values below - AnalysisUpsellPopupComponent is never opened for VI
                // (see NavbarComponent.openSubItemUpsell), so this content is never shown. Required
                // only to satisfy NavItemUpsellPopup's shape until marketing message is received.
                icon: 'fa-kit-duotone fa-agpr-ai-visibility',
                heading: 'Visibility Intelligence',
                message: 'Visibility Intelligence',
                bullets: ['Visibility Intelligence'],
                endMessage: 'Visibility Intelligence',
                featureName: 'Visibility Intelligence',
                // TODO: NEP-38233 - switch back to HubspotFormTypeEnum.VISIBILITY_INTELLIGENCE once that form
                // field (upsell_inquiry10-<formId>) exists on the HubSpot side - reusing AGENTIC_FEATURES for now
                hubspotFormType: HubspotFormTypeEnum.AGENTIC_FEATURES,
                confirmationHeading: 'Core.navigation.mediaRelations.visibilityIntelligence.upsell.confirmation.heading',
                confirmationMessage: 'Core.navigation.mediaRelations.visibilityIntelligence.upsell.confirmation.message'
            }
        }
    ],
    upsellMessage: 'Core.navigation.mediaRelations.unlock'
};
